module.exports = __webpack_public_path__ + "media/images/symbols/blue-caret-left-41c4dce3554333cec94ab95982648db4.svg";